const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const isAnalyticsReady = () =>
  typeof window !== "undefined" &&
  typeof window.gtag === "function" &&
  !!GA_ID;

export const trackPageView = ({ page_path, page_title, page_location }) => {
  if (!isAnalyticsReady()) return;

  window.gtag("event", "page_view", {
    page_path,
    page_title,
    page_location,
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (!isAnalyticsReady()) return;

  window.gtag("event", eventName, params);
};

export const analyticsEvents = {
  search: ({ searchTerm, screenName, language }) =>
    trackEvent("search", {
      search_term: searchTerm,
      screen_name: screenName,
      language,
    }),

  selectCategory: ({ categoryName, screenName, language }) =>
    trackEvent("select_category", {
      category_name: categoryName,
      screen_name: screenName,
      language,
    }),

  selectStore: ({ storeName, screenName, language }) =>
    trackEvent("select_store", {
      store_name: storeName,
      screen_name: screenName,
      language,
    }),

  viewItem: ({ item, language, screenName }) =>
    trackEvent("view_item", {
      currency: "USD",
      value: Number(item.price || 0),
      screen_name: screenName,
      language,
      items: [
        {
          item_id: item.productid,
          item_name: item.name,
          item_category: item.matched_category || item.category,
          item_brand: item.store,
          price: Number(item.price || 0),
          quantity: 1,
        },
      ],
    }),

  addToCart: ({ item, quantity = 1, language, screenName }) =>
    trackEvent("add_to_cart", {
      currency: "USD",
      value: Number(item.price || 0) * quantity,
      screen_name: screenName,
      language,
      items: [
        {
          item_id: item.productid,
          item_name: item.name,
          item_category: item.matched_category || item.category,
          item_brand: item.store,
          price: Number(item.price || 0),
          quantity,
        },
      ],
    }),

  removeFromCart: ({ item, quantity = 1, language, screenName }) =>
    trackEvent("remove_from_cart", {
      currency: "USD",
      value: Number(item.price || 0) * quantity,
      screen_name: screenName,
      language,
      items: [
        {
          item_id: item.productid,
          item_name: item.name,
          item_category: item.matched_category || item.category,
          item_brand: item.store,
          price: Number(item.price || 0),
          quantity,
        },
      ],
    }),

  changeItemQuantity: ({
    item,
    quantity,
    previousQuantity,
    language,
    screenName,
  }) =>
    trackEvent("change_item_quantity", {
      item_id: item.productid,
      item_name: item.name,
      category_name: item.matched_category || item.category,
      store_name: item.store,
      price: Number(item.price || 0),
      quantity,
      previous_quantity: previousQuantity,
      screen_name: screenName,
      language,
    }),

  viewAlternativeItems: ({ categoryName, alternativesCount, language, screenName }) =>
    trackEvent("view_alternative_items", {
      category_name: categoryName,
      alternatives_count: alternativesCount,
      screen_name: screenName,
      language,
    }),

  selectAlternativeItem: ({ item, language, screenName }) =>
    trackEvent("select_alternative_item", {
      item_id: item.productid,
      item_name: item.name,
      category_name: item.matched_category || item.category,
      store_name: item.store,
      price: Number(item.price || 0),
      screen_name: screenName,
      language,
    }),

  runBasketAnalysis: ({
    categoriesCount,
    storesCount,
    itemsCount,
    language,
    screenName,
  }) =>
    trackEvent("run_basket_analysis", {
      categories_count: categoriesCount,
      stores_count: storesCount,
      items_count: itemsCount,
      screen_name: screenName,
      language,
    }),

  viewBasketResults: ({
    itemsCount,
    categoriesCount,
    storesCount,
    totalPrice,
    savingsAmount,
    language,
    screenName,
  }) =>
    trackEvent("view_basket_results", {
      items_count: itemsCount,
      categories_count: categoriesCount,
      stores_count: storesCount,
      total_price: Number(totalPrice || 0),
      savings_amount: Number(savingsAmount || 0),
      screen_name: screenName,
      language,
    }),

  clickViewInShopper: ({ item, language, screenName }) =>
    trackEvent("click_view_in_shopper", {
      item_id: item.productid,
      item_name: item.name,
      category_name: item.matched_category || item.category,
      store_name: item.store,
      shopper_url: item.shopper_url || "",
      screen_name: screenName,
      language,
    }),

  shareCartOpened: ({
    itemsCount,
    categoriesCount,
    storesCount,
    totalPrice,
    savingsAmount,
    language,
    screenName,
  }) =>
    trackEvent("share_cart_opened", {
      items_count: itemsCount,
      categories_count: categoriesCount,
      stores_count: storesCount,
      total_price: Number(totalPrice || 0),
      savings_amount: Number(savingsAmount || 0),
      screen_name: screenName,
      language,
    }),

  shareCart: ({
    method,
    itemsCount,
    categoriesCount,
    storesCount,
    totalPrice,
    savingsAmount,
    language,
    screenName,
  }) =>
    trackEvent("share_cart", {
      method,
      items_count: itemsCount,
      categories_count: categoriesCount,
      stores_count: storesCount,
      total_price: Number(totalPrice || 0),
      savings_amount: Number(savingsAmount || 0),
      screen_name: screenName,
      language,
    }),

  shareCartError: ({ method, errorMessage, language, screenName }) =>
    trackEvent("share_cart_error", {
      method,
      error_message: errorMessage,
      screen_name: screenName,
      language,
    }),

  apiError: ({ endpoint, errorMessage, screenName }) =>
    trackEvent("api_error", {
      endpoint,
      error_message: errorMessage,
      screen_name: screenName,
    }),
};